import $ from 'jquery';
import _, { forEach } from 'underscore';
import Backbone from 'backbone';
import LazyLoad from 'vanilla-lazyload';

import 'jquery-hoverintent';
import 'scrolltofixed';
import 'slick-carousel';

// import { swiffyslider } from 'swiffy-slider';
// import "swiffy-slider/css";

import ViewHome from '@/views/view-home';
import ViewAbout from '@/views/view-about';

import OneDrawer from '@/modules/module-oneDrawer';
import OneSubscribe from '@/modules/module-oneSubscribe';
import OneCookieBanner from '@/modules/module-oneCookieBanner';
import OneMobileMenu from '@/modules/module-oneMobileMenu';
import OneMarketing from '@/modules/module-oneMarketing';
import OneVerification from '@/modules/module-oneVerification';
import OnePredictiveSearch from '@/modules/module-onePredictiveSearch';
import OneCart from '@/modules/module-oneCart';
import OneGWP from '@/modules/module-oneGWP';
import OneSP from '@/modules/module-oneSP';
import OneQuickShop from '@/modules/module-oneQuickShop';
import OneSwiffySlider from '@/modules/module-oneSwiffySlider';
import { PUB_SUB_EVENTS, subscribe } from '@/lib/pubsub';



export default Backbone.View.extend({
    
    initialize: function (opts) {
        
        console.log('init global');
        
        // Testing $ object
        // console.log($.fn.jquery);
        
        var self = this;
        self.$body = self.$el;
        self.$header = $('header.site-header');
        self.$footer = $('footer.site-footer');
        self.$miniCart = $('#MiniCart');
        self.$mobileNav = $('#MobileNav');
        self.$searchBar = $('#SearchBar');
        self.$promoBanner = self.$header.find('.promo-banner');
        self.$navi = self.$header.find('nav.nav-bar');
        self.$menuToggle = self.$header.find('.menu-toggle');
        
        self.searchInlineMode = false; // Set false to use search modal, set true to use inline search mode. 
        self.miniCartAsDropdown = false; // Set false to use drawer, set true to use dropdown on Desktop (drawer on Mobile).
        self.useSlideInMenuForLevel2 = true; // Set false to use accordion for all nav levels on Mobile, set true to use the slide-in-menu for level 2.

        self.initLazyImages();
        self.initPromoBanner();
        self.initCookieBanner();
        self.initFixedHeader();
        self.initNavi();
        self.initUtilities();
        self.initSearch();
        self.initPredictiveSearch();
        self.initMiniCart();
        self.initMobileMenu();
        self.initSubscirbe();
        self.initFooter();
        self.initModules();
        self.initQuickShop();
        self.initFeaturedCollections();
        self.initFeaturedSection();
        self.initResourcesModule();
        self.devTools();

        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing ||  new OneMarketing;
            ORW.marketing.initPromoWatchers();
            ORW.marketing.initWishlistWatcher();

            if (ORW.verification) {
                OneVerification.init({ marketing: ORW.marketing });
            }
        }

        if (ORW.GWP && ORW.GWP.enable == `true`) {
            OneGWP.init()
        }

        if (ORW.SP && ORW.SP.enable == `true`) {
            OneSP.init()
        }
    },

    events: {
        'drawer-opt' : 'bodyClassCtl',
        'menu-opt-in' : 'bodyClassCtl',
        'menu-opt-out' : 'bodyClassCtl'
    },
    
    bodyClassCtl : function(e){
        // Please prevent operation on more then one drawer at the same time
        var self = this;
        var type = e.type;
        if (type == 'drawer-opt') {
            self.$body.toggleClass('drawer-opt');
            self.$body.toggleClass('show-overlay');
        } else {
            if(ORW.transparentHeaderEnabled) {
                if (type == 'menu-opt-in') {
                    self.$body.addClass('show-overlay');
                    self.$header.addClass('menu-opt-in');
                } else if (type == 'menu-opt-out') {
                    self.$body.removeClass('show-overlay');
                    self.$header.removeClass('menu-opt-in');
                }
            }
        }
    },

    initModules: function(){
        new ViewHome({el: $('#MainContent')});
        new ViewAbout({el: $('#MainContent')});
    },

    initLazyImages: function() {
        window.ORW.lazyload = new LazyLoad({ threshold: 0 });

        const events = {
            'mouseenter .product-image-wrapper' (e) {
                $(e.currentTarget).find('.product-image.alt').removeClass('hide');
            },
        };

        _.extend(this.events, events);
        this.delegateEvents();
    },

    initPromoBanner: function(){
        var self = this;
        var cookieEnabled = self.$promoBanner.data('cookieenabled');
        var cookieDays = self.$promoBanner.data('days');

        if(self.$promoBanner.length > 0){
            // if(!ORW.utilities.getCookie('promo_banner') && self.$body.hasClass('template-index')){
            if(!ORW.utilities.getCookie('promo_banner')) {
                self.$body.addClass('promo-banner-active');
                self.$promoBanner.addClass('activate');
            }

            if (self.$promoBanner.data('slider') == 'true' || self.$promoBanner.data('slider') == true) {
                const slider = self.$promoBanner.find(`.swiffy-slider`)[0]
                OneSwiffySlider(slider)
            }
        }

        var events = {
            'click .close-promo' : function(e){
                self.$promoBanner.slideUp(200);
                self.$body.removeClass('promo-banner-active');
                self.$promoBanner.removeClass('activate');

                if(!ORW.utilities.getCookie('promo_banner') && cookieEnabled ){
                    ORW.utilities.setCookie('promo_banner','shown', cookieDays);
                }
            }
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initCookieBanner: function(){
        var self = this;
        if ($('.cookie-banner').length) {
            ORW.cookieBanner = OneCookieBanner.init({
                el: $('.cookie-banner')
            });
        }
    },
    
    initFixedHeader: function() {
        var self = this;
        // Uncomment following code if you need better control on fixed header scrolling, by default the header always fixed by CSS 
        self.$header.scrollToFixed({
            dontSetWidth : true
        });
        
        // Mobile header scroll control
        var lastScrollTop = 0;
        var mobileHeaderHeight = 44;
        var checkScrollDirection = function(){
            var st = $(window).scrollTop();
            if (st > lastScrollTop && st >= mobileHeaderHeight){
                // downscroll code
                if (st - lastScrollTop >= 10) {
                    self.$header.removeClass('scroll-up').addClass('scroll-down');
                }
            } else {
                // upscroll code
                self.$header.removeClass('scroll-down');
                self.$header.addClass('scroll-up');
                if (st < mobileHeaderHeight) {
                    self.$header.removeClass('scroll-up');
                }
            }
            lastScrollTop = st;
        }

        checkScrollDirection();
        $(window).scroll(function(event){
            checkScrollDirection();
        });
    },
    
    initNavi: function() {
        var self = this;
        
        self.$rawNav = self.$navi.clone();
        
        // Build mobile Nav
        var $slideInMenu = $('<div class="slide-in-menu"></div>');
        var $clonedNavi = self.$navi.clone();
        _.each($clonedNavi.find('.has-dropdown'), function(child){
            var $child = $(child);
            var $dropdown = $child.find('.dropdown');

            // For DBDB only
            if ($dropdown.hasClass(`all-blocks`)) {
                // Preserve the image blocks
                const $lv2_image_blocks = $dropdown.find('.lv2-image .inner-wrapper');                
                let lv3_link_new_html = '';
                _.each($lv2_image_blocks, (block) => {
                    const $block = $(block);
                    const title = $block.find(`.nav-image-title`).text();
                    const link = $block.find(`a`).attr(`href`);
                    lv3_link_new_html += `
                        <li class="level-2">
                            <a class="nav-link" href="${link}"><span>${title}</span></a>
                        </li>
                    `
                })
                $(lv3_link_new_html).appendTo($dropdown);
                $dropdown.find('.lv2-image').remove();
            }
            // For DBDB only - END
            $dropdown.find('.lv2-image').remove();
            
            if (self.useSlideInMenuForLevel2) {
                $dropdown.appendTo($slideInMenu);
                $child.find('.dropdown').remove();  
            } else {
                $dropdown.appendTo($child);
                $child.find('.dropdown-wrapper').remove();
                $child.find('.nav-link').removeAttr('data-trigger');
                $child.addClass('expandable');
            }
        });
        
        if (self.useSlideInMenuForLevel2) {
            $slideInMenu.appendTo($clonedNavi);
        }

        _.each($clonedNavi.find('.level-2.mobile-expand-default.expandable'), function(item){
            var $item = $(item);
            var $children = $item.children('.children');
            if ($children.length) {
                $item.addClass('active');
                $children.show();
            }
        });

        self.$mobileNav.find('.header-utilities').before($clonedNavi);
        
        // Build desktop nav (uncomment below code block to enable automatical column distribution based on column size setting)
        // _.each(self.$navi.find('.children.column-layout'), function(child){
        //     var currentCol = 0, html = '<li class="back-to">Back</li>';
        //     var $child = $(child);
        //     var $level2 = $child.find('.level-2');
        //     var $level2Images = $child.find('.lv2-image'); 
            
        //     _.each($level2, function(item,index){
        //         var $item = $(item);
        //         var isLast = index == $level2.length-1 ? true : false;
                
        //         if (currentCol == 0 && currentCol != $item.data('column')) {
        //             html += '<li class="divider"><ul>';
        //             currentCol = $item.data('column');
        //         } else if (currentCol != $item.data('column')) {
        //             html += '</ul></li><li class="divider"><ul>';
        //             currentCol = $item.data('column');
        //         }
                
        //         html += $('<div>').append($item.clone()).html();
                
        //         if (isLast) {
        //             html += '</ul></li>';
        //         }
        //     });
            
        //     _.each($level2Images, function(item){
        //         html += $(item)[0].outerHTML;
        //     });
            
        //     $child.html(html);
        // });
    },
    
    initUtilities: function() {
        var self = this;
        var events = {};
        
        // Header hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-in');
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-out');
                }
            },
            sensitivity: 100
        });
        
        // Header dropdown hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                let search_bar = $('#SearchBar');
                if (!self.isMobile() && !search_bar.hasClass('opened')) {
                    $(this).addClass('active');
                    if (self.miniCartTimer) {
                        // Check if minicart close timer exists, if so kill it.
                        console.log('kill timer');
                        clearTimeout(self.miniCartTimer);
                    }
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    $(this).removeClass('active');
                }
            },
            sensitivity: 100,
            selector: '.has-dropdown:not(.block-search)'
        });
        
        // Copy extra links (if available) to Mobile menu utilities (Small screen)
        var $extraLinkContainer = self.$header.find('.header-extra-links');
        if ($extraLinkContainer.length) {
            $extraLinkContainer = $extraLinkContainer.clone();
            self.$mobileNav.find('.header-utilities').prepend($extraLinkContainer.html());
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initSearch: function(){
        var self = this;
        if (self.searchInlineMode) {
            self.$header.hoverIntent({
                over: function(){
                    var $target = $(this).find('.block-content');
                    $target.on('transitionend', function(){
                        $target.off('transitionend');
                        setTimeout(function(){ $target.find('input').focus(); },100);
                    });
                    $(this).addClass('active');
                },
                out: function(){
                    $(this).removeClass('active');
                },
                sensitivity: 100,
                selector: '.block-search'
            });
        } else {
            self.searchCtl = OneDrawer.init({
                drawerElem: '#' + self.$searchBar.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .search-toggle',
                openCallback: function(){
                    setTimeout(function(){ self.$searchBar.find('input').focus(); },100);
                    $(self.searchCtl.triggerElem).addClass(`active`);
                },
                closeCallback: function(){
                    $(self.searchCtl.triggerElem).removeClass(`active`);
                },
                events: {
                    'click .search-form button' : function(e){
                        e.preventDefault();
                        var $form = $(e.currentTarget).parent('form');
                        if ($form.find('input').val()) {
                            this.closeDrawer();
                            $form.submit();
                        } else {
                            // May be show error message ...
                        }
                    }
                }
            });
        }
    },

    initPredictiveSearch: function() {
        var self = this;
        if ($('.predictive-search-form').length) {
            ORW.predictiveSearchModal = OnePredictiveSearch.init({
                el: $('.predictive-search-form')
            });
        }
    },
    
    initMobileMenu: function(){
        var self = this;
        
        self.mobileMenuCtl = OneDrawer.init({
            drawerElem: '#' + self.$mobileNav.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .menu-toggle',
            openCallback: function(e){
                self.$menuToggle.find('.animated-hamburger, .hamburger').addClass('open');
                self.$body.trigger('menu-opt-in');
            },
            closeCallback: function(e){
                self.$menuToggle.find('.animated-hamburger, .hamburger').removeClass('open');
                self.$body.trigger('menu-opt-out');
            }
        });
        
        self.mobileInnerMenuCtl = OneMobileMenu.init({
            el: self.$mobileNav,
            openCallback: function(e){
                self.$mobileNav.addClass('inner-action-engaged');
                self.$menuToggle.find('.animated-hamburger, .hamburger').addClass('inner-action-engaged');
            },
            closeCallback: function(e){
                self.$mobileNav.removeClass('inner-action-engaged');
                self.$menuToggle.find('.animated-hamburger, .hamburger').removeClass('inner-action-engaged');
            }
        });
    },
    
    initMiniCart: function() {
        var self = this;
        var miniCartDrawerInit = function(){
            console.log('init minicart as drawer');
            return OneDrawer.init({
                drawerElem: '#' + self.$miniCart.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .block-minicart',
                openCallback: function(){}
            });
        };
        var miniCartDropdownOpen = function(){
            self.$body.trigger('menu-opt-in');
            self.$header.find('.block-minicart').addClass('active');
        }
        var miniCartDropdownClose = function(){
            self.$header.find('.block-minicart').removeClass('active');
            self.$body.trigger('menu-opt-out');
        }
        
        self.miniCartCtl = miniCartDrawerInit();
        
        $('.add-to-cart-form').off('submit');
        
        if (self.miniCartAsDropdown) {
            // Init minicart as Dropdown on Desktop
            
            ORW.utilities.mediaCheck(function () {
                if (self.miniCartCtl) {
                    console.log('minicart drawer destory');
                    self.miniCartCtl.destroy();
                    self.miniCartCtl = false;
                }
            }, function () {
                if (!self.miniCartCtl) {
                    self.miniCartCtl = miniCartDrawerInit();
                }
            })
        }

        const miniCartElem = document.querySelector('#CartContainer form.cart');
        if (miniCartElem) {
            new OneCart({ el: miniCartElem });
        }

        self.unsubscribeMiniCart = subscribe(PUB_SUB_EVENTS.cartUpdate, async (data) => {
            
            const cart = await fetch('/cart.js').then(res => res.json());
            // document.querySelectorAll('.minicart-count').forEach(el => {
            //     el.innerHTML = cart.item_count;
            // });

            if (window.location.pathname === '/cart') return;
            if (self.miniCartCtl.drawerOpened) return;

            clearTimeout(self.miniCartTimer);
            if (self.miniCartCtl) {
                self.miniCartCtl.openDrawer();
                //comment code which close drawer automatically after 3 seconds
               // self.miniCartTimer = setTimeout(function(){ self.miniCartCtl.closeDrawer(); }, 3000);
            } else {
                miniCartDropdownOpen();
                self.miniCartTimer = setTimeout(function(){ miniCartDropdownClose(); }, 3000);
            }
        })
    },
    
    initSubscirbe: function() {
        var self = this;
        if ($('.subscribe-modal').length) {
            ORW.subscribeModal = OneSubscribe.init({
                el: $('.subscribe-modal')
            });
        }
    },

    initQuickShop: function() {
        const self = this

        if (document.querySelector(`.quick-shop-trigger`) || document.querySelector(`.quick-shop-trigger-link`)) {
            OneQuickShop.init({})
        }
    },

    initResourcesModule: function() {
        const $sliders = $('[data-resources-slider]');
        if (!$sliders.length) return;

        $sliders.each(function() {
            $(this).slick({
                dots: true,
                arrows: true,
                infinite: false,
                speed: 400,
                slidesToShow: 4,
                slidesToScroll: 1,
                // adaptiveHeight: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: ORW.responsiveSizes.large,
                        settings: {
                            variableWidth: true,
                            slidesToShow: 2,
                            arrows: false,
                            dots: true
                        }
                    },
                    {
                        breakpoint: ORW.responsiveSizes.medium,
                        settings: {
                            variableWidth: true,
                            slidesToShow: 1,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });
        });

        var events = {
            'click [data-resource-play]': function(e) {
                e.preventDefault();
                var $card = $(e.currentTarget).closest('.resources-module__card');
                var $player = $card.find('[data-resource-player]');
                if (!$player.length) return;

                $card.find('.resources-module__thumbnail-image, .resources-module__video-overlay').hide();
                $player.show();

                var $video = $player.find('video');
                if ($video.length) {
                    $video[0].play();
                } else {
                    var $iframe = $player.find('iframe');
                    if ($iframe.length) {
                        var src = $iframe.attr('src');
                        if (src.indexOf('autoplay') === -1) {
                            $iframe.attr('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
                        }
                    }
                }
            }
        };
        _.extend(this.events, events);
        this.delegateEvents();
    },

    initFeaturedCollections: function() {
        const $sliders = $('.featured-collections [data-featured-collections-slider] .cards');
        if (!$sliders.length) return;

        $sliders.each(function() {
            const $cards = $(this);
            $cards.slick({
                dots: false,
                arrows: true,
                infinite: false,
                speed: 400,
                slidesToShow: 1,
                slidesToScroll: 2,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: ORW.responsiveSizes.medium,
                        settings: 'unslick'
                    }
                ]
            });
        });
    },

    initFeaturedSection: function() {
        const $slider = $('.global-featured-section__blocks');
        $slider.slick({
            dots: false,
            arrows: false,
            variableWidth: false,
            infinite: false,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: ORW.responsiveSizes.large + 1,
                    settings: {
                        dots: true,
                        infinite: true,
                        slidesToShow: 1,
                        variableWidth: true
                    }
                }
            ]
        });
    },
    
    initFooter: function() {
        var self = this;
        var events = {
            'click footer.site-footer .expandable': function(e){
                if (self.isMobile()) {
                    var $curr = $(e.currentTarget);
                    var $activeSiblings = $curr.siblings('.expandable.active');
                    if ($activeSiblings.length) {
                        $activeSiblings.removeClass('active');
                    }
                    $curr.toggleClass('active');
                }
            }
        };
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    },

    devTools: function(){
        var self = this;
        var $indicator = $('#responsive-indicator');
        var $previewBar = $('#preview-bar-iframe');

         // This should only run when a theme is being previewed.
        if(Shopify.PreviewBarInjector !== undefined){
            if($indicator.length > 0 && $previewBar.length > 0 && Shopify.PreviewBarInjector.length == 1){
                $indicator.text("Preview: " + Shopify.theme.name).removeClass("hide");
                var events = {
                    'click #responsive-indicator': function(e){
                        $indicator.toggleClass('active');
                        $previewBar.toggleClass('active');
                    }
                };

                _.extend(self.events, events);
                self.delegateEvents();
            }else{
                $indicator.addClass("hide");
            }
        }
    }
});
